export const RideShare = [
    {
        id: 1,
        name: 'Pool or Shared rides',
    },
    {
        id: 2,
        name: 'XL',
    },
    {
        id: 3,
        name: 'Black or Lux',
    },
    {
        id: 4,
        name: 'Wheelchair-accessible',
    },
    {
        id: 5,
        name: 'Food delivery',
    },
];

export const RideShareStatus = [
    {
        label: 'Select',
        value: '',
    },
    {
        label: 'Part-Time (under 30 hours a week)',
        value: 'part_time',
    },
    {
        label: 'Full-Time (over 30 hours a week)',
        value: 'full_time',
    },
];

export const RideShareEmployer = [
    {
        label: 'Select',
        value: '',
    },
    {
        label: 'Uber',
        value: 'Uber',
    },
    {
        label: 'Lyft',
        value: 'Lyft',
    },
    {
        label: 'Other Rideshare Platform(s)',
        value: 'Other',
    },
];
